// Master registry of all available sets
// Each set has its own data file in /sets/

export const SET_REGISTRY = [
  {
    id: '2026-chrome',
    type: 'Chrome',
    name: '2026 Topps Chrome Star Wars',
    shortName: '2026 Chrome',
    year: 2026,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'September 30, 2026',
    totalCards: 1275,
    description: 'The 2026 flagship Chrome release — a 200-card base set with 44 debut characters, Aurebesh versions of all 200, a Refractor rainbow with the new Star Wars LogoFractor /77 and the icy Hoth FrozenFractor /5, Andor Season 2, Visions Season 3 and The Mandalorian and Grogu inserts, 181 Character Autographs plus duos and triples, and 173 sketch artists.',
    color: '#00e87a',
    accentColor: '#f0c040',
    dataFile: '2026-chrome',
    // No `sets` DB row yet, so the browse grid falls back to this field.
    section: 'chrome-sw',
    new: true,
    // Set Summary card gallery (CK base photos, full 200 + backs), also used
    // as the My Checklist thumbnail fallback.
    summaryGallery: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base'],
      checklistFallback: true,
    },
  },
  {
    id: '2026-chrome-sapphire',
    type: 'Sapphire',
    name: '2026 Topps Chrome Sapphire Star Wars',
    shortName: '2026 Chrome Sapphire',
    year: 2026,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'October 28, 2026',
    totalCards: 438,
    description: 'The Sapphire Edition of 2026 Topps Chrome Star Wars — the 200-card base set on Sapphire stock with a Gold, Orange, Black, Red and Padparadscha Sapphire ladder, the new Hidden Gems and Kyber Carvings Sapphire inserts, 182 Characters Autographs, Kyber Carvings autographs, and duo and triple autographs.',
    color: '#4d9fff',
    accentColor: '#f0c040',
    dataFile: '2026-chrome-sapphire',
    // No `sets` DB row yet, so the browse grid falls back to this field.
    section: 'sapphire',
    new: true,
  },
  {
    id: '2026-galaxy',
    type: 'Galaxy',
    name: '2026 Topps Chrome Star Wars Galaxy',
    shortName: '2026 Galaxy',
    year: 2026,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'August 12, 2026',
    totalCards: 100,
    description: 'The sixth Chrome Galaxy — 100 base cards of new and classic Galaxy artwork, a 17-deep parallel rainbow, Knights of the Republic and Duel on Cloud City inserts, and an 85-card autograph program.',
    color: '#00e87a',
    accentColor: '#f0c040',
    dataFile: '2026-galaxy',
    // Set Summary card gallery. Points at CK's own reference photos in the
    // public card-images bucket (prod URL so every environment renders them);
    // sections lists which checklist section ids have photo coverage.
    summaryGallery: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base'],
      // Also use these reference photos as the My Checklist thumbnail fallback
      // for cards the collector hasn't photographed (gold corner triangle).
      checklistFallback: true,
    },
  },
  {
    id: '2026-the-national',
    type: 'Chrome',
    name: '2026 Topps Star Wars The National',
    shortName: '2026 Chrome The National',
    year: 2026,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'July 29, 2026',
    totalCards: 98,
    description: 'Show-exclusive Star Wars box from the 2026 NSCC Collection — 50 National Refractor base cards pairing actors with their characters, a nine-deep parallel ladder topped by the NSCC Annual /26, a 38-card autograph parallel program, and the five Star Wars subjects of the cross-sport National Collection insert with their autographs.',
    color: '#b060ff',
    accentColor: '#f0c040',
    dataFile: '2026-the-national',
  },
  {
    id: '2024-chrome-black',
    type: 'Black',
    name: '2024 Topps Chrome Black Star Wars',
    shortName: 'Chrome Black 2024',
    year: 2024,
    brand: 'Topps Chrome Black',
    category: 'Star Wars',
    releaseDate: '2024',
    totalCards: 100,
    description: 'Ultra-premium Chrome Black release featuring 100 base cards, 95 insert cards, and 228 autographs.',
    color: "#ff4444",
    accentColor: '#f0c040',
    dataFile: '2024-chrome-black',
  },
  {
    id: '2024-topps-chrome-sw',
    type: 'Chrome',
    name: '2024 Topps Chrome Star Wars',
    shortName: '2024 Chrome',
    year: 2024,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: '2024',
    totalCards: 150,
    description: 'The definitive 2024 Chrome release featuring 150 base cards across the full Star Wars universe.',
    color: '#ff4444',
    accentColor: '#f0c040',
    dataFile: '2024-topps-chrome-sw',
    // My Checklist reference-photo fallback (CK base photos, full 150 + backs).
    checklistFallback: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base'],
    },
  },
  {
    id: '2024-high-tek',
    type: 'Other',
    name: '2024 Topps Star Wars High-Tek',
    shortName: 'High-Tek 2024',
    year: 2024,
    brand: 'Topps High-Tek',
    category: 'Star Wars',
    releaseDate: 'January 8, 2025',
    totalCards: 100,
    description: 'A 100-card base set across seven design patterns (Throne Room, Hyperspace, Imperial, Laser, Rebel, Death Star Interior & Exterior), each with its own tiered diffractor ladder, plus Tek-themed inserts and a 55-signer autograph program.',
    color: '#00bcd4',
    accentColor: '#f0c040',
    dataFile: '2024-high-tek',
  },
  {
    id: '2024-hyperspace',
    type: 'Hyperspace',
    name: '2024 Topps Star Wars Hyperspace',
    shortName: 'Hyperspace 2024',
    year: 2024,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'February 19, 2025',
    totalCards: 100,
    description: 'The first Hyperspace — a Chrome set spanning five planets: Naboo, Kashyyyk, Hoth, Bespin and Mustafar — with serial /99 planetary variations, seven insert lines, a 46-signer autograph program, and sketch cards.',
    color: '#00b0ff',
    accentColor: '#c9b6ff',
    dataFile: '2024-hyperspace',
  },
  {
    id: '2025-hyperspace',
    type: 'Hyperspace',
    name: '2025 Topps Star Wars Hyperspace',
    shortName: 'Hyperspace 2025',
    year: 2025,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'December 30, 2025',
    totalCards: 100,
    description: 'A Chrome set spanning five planets — Alderaan, Corellia, Lothal, Mandalore and Tatooine — with planetary variations, shadowbox inserts, an on-card autograph variation program, and sketch cards.',
    color: '#7c4dff',
    accentColor: '#00d4ff',
    dataFile: '2025-hyperspace',
  },
  {
    id: '2025-chrome-galaxy',
    type: 'Galaxy',
    name: '2025 Topps Chrome Star Wars Galaxy',
    shortName: '2025 Galaxy',
    year: 2025,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'December 10, 2025',
    totalCards: 100,
    description: 'Celebrating the 20th Anniversary of Revenge of the Sith and 10th Anniversary of The Force Awakens.',
    color: '#b060ff',
    accentColor: '#f0c040',
    dataFile: '2025-chrome-galaxy',
    // My Checklist reference-photo fallback only (no public Set Summary
    // gallery for this set) — CK base photos in the public card-images bucket.
    checklistFallback: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base'],
    },
  },
  {
    id: '2025-chrome',
    type: 'Chrome',
    name: '2025 Topps Chrome Star Wars',
    shortName: '2025 Chrome',
    year: 2025,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'August 20, 2025',
    totalCards: 1423,
    description: 'The flagship 2025 Chrome release featuring a 200-card base set, twenty insert sets, and an extensive autograph program.',
    color: '#00e87a',
    accentColor: '#f0c040',
    dataFile: '2025-chrome',
    // My Checklist reference-photo fallback (CK base photos, full 200 + backs).
    checklistFallback: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base'],
    },
  },
  {
    id: '2025-chrome-sapphire',
    type: 'Sapphire',
    name: '2025 Topps Chrome Sapphire Star Wars',
    shortName: '2025 Chrome Sapphire',
    year: 2025,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: '2025',
    totalCards: 358,
    description: 'The Sapphire Edition of 2025 Topps Chrome Star Wars — a 200-card base set on Sapphire stock with a colored Sapphire parallel ladder, the Sapphire Selections insert, and single, duo and trio autographs.',
    color: '#4d9fff',
    accentColor: '#f0c040',
    dataFile: '2025-chrome-sapphire',
    new: true,
  },
  {
    id: '2024-chrome-sapphire',
    type: 'Sapphire',
    name: '2024 Topps Star Wars Chrome Sapphire Edition',
    shortName: '2024 Chrome Sapphire',
    year: 2024,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'May 4, 2024',
    totalCards: 187,
    description: 'The Phantom Menace 25th Anniversary — the first Sapphire built as its own product. A 100-card base set retelling Episode I, Duel of the Fates, Jedi High Council, Podracing and Sapphire Selections inserts, and original cast autographs including Keira Knightley’s first certified Star Wars autograph.',
    color: '#4d9fff',
    accentColor: '#f0c040',
    dataFile: '2024-chrome-sapphire',
    new: true,
  },
  {
    id: '2024-chrome-galaxy',
    type: 'Galaxy',
    name: '2024 Topps Chrome Star Wars Galaxy',
    shortName: '2024 Galaxy',
    year: 2024,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'November 1, 2024',
    totalCards: 100,
    description: 'Celebrating the 25th Anniversary of The Phantom Menace and the Year of the Sith.',
    color: '#00d4ff',
    accentColor: '#c9a227',
    dataFile: '2024-chrome-galaxy',
    // My Checklist reference-photo fallback only (no public Set Summary
    // gallery for this set). NOTE: this set's storage objects use legacy
    // UNPREFIXED keys (base__7__front, not 2024-chrome-galaxy__base__7__front)
    // — referenceImageUrl applies the same strip as imagePath.
    checklistFallback: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base'],
    },
  },
  {
    id: '2023-chrome-sapphire',
    type: 'Sapphire',
    name: '2023 Topps Star Wars Sapphire Return of the Jedi 40th Anniversary',
    shortName: '2023 Chrome Sapphire ROTJ',
    year: 2023,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'July 12, 2023',
    totalCards: 283,
    description: 'The complete 1983 Topps Return of the Jedi set reborn on Sapphire stock — all 220 cards across Series 1 and Series 2, 55 Chrome Sticker Reprints rebuilding the four original puzzle backs, and the Star Wars Sapphire line\'s first autographs: an eight-signer Return of the Jedi cast program.',
    color: '#4d9fff',
    accentColor: '#f0c040',
    dataFile: '2023-chrome-sapphire',
    new: true,
  },
  {
    id: '2023-finest',
    type: 'Other',
    name: '2023 Topps Finest Star Wars',
    shortName: 'Finest 2023',
    year: 2023,
    brand: 'Topps Finest',
    category: 'Star Wars',
    releaseDate: 'November 29, 2023',
    totalCards: 311,
    description: 'Finest returns to the galaxy — 100 base cards under a nine-step Refractor rainbow, a 25-card Extended Base short print run, four inserts (Tales of the Jedi, Finest Moments, Finest Warriors, and the foil-board Enemies of the Empire with its Broken Glass 1/1), a 44-signer Finest Autographs program with a Wave twin at every colour, six Prime Autographs numbered to 10, and both standard and shaped sketch cards.',
    color: '#2ee6c8',
    accentColor: '#f0c040',
    dataFile: '2023-finest',
  },
  {
    id: '2023-nycc',
    type: 'Other',
    name: '2023 Topps Star Wars New York Comic Con',
    shortName: 'NYCC 2023',
    year: 2023,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'October 12, 2023',
    totalCards: 15,
    description: 'Show-exclusive promo set from New York Comic Con 2023 — 15 white-bordered cards of 2023 flagship imagery with the NYCC logo on the back, handed out in five-card cello packs at the Topps booth. No parallels; the full run is 15 cards.',
    color: '#ff4444',
    accentColor: '#f0c040',
    dataFile: '2023-nycc',
  },
  {
    id: '2023-nycc-sparkle',
    type: 'Other',
    name: '2023 Topps Star Wars NYCC Sparkle Packs',
    shortName: 'NYCC Sparkle 2023',
    year: 2023,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'October 12, 2023',
    totalCards: 20,
    description: 'The other NYCC 2023 exclusive — 20 cards of 2023 flagship imagery with sparkle-foil borders, one four-card pack per High Tek box bought at the Topps booth. The standard card is an unnumbered Silver Sparkle, with Blue /75, Gold /50, Orange /25 and Red /5 Sparkle variants under a FoilFractor 1/1.',
    color: '#e8e8ec',
    accentColor: '#f0c040',
    dataFile: '2023-nycc-sparkle',
  },
  {
    id: '2022-finest',
    type: 'Other',
    name: '2022 Topps Finest Star Wars',
    shortName: 'Finest 2022',
    year: 2022,
    brand: 'Topps Finest',
    category: 'Star Wars',
    releaseDate: 'July 29, 2022',
    totalCards: 375,
    description: 'The Finest revival — 100 base cards under an eight-step Refractor rainbow, a 20-card Extended Base run, four themed inserts drawn from The Mandalorian, The Book of Boba Fett, The Bad Batch and The High Republic, the die-cut Galaxy\'s Finest Heroes, and the deepest autograph program in the line: 70 Finest Autographs with a nine-tier ladder topped by a Purple /299, plus die-cut, Mandalorian, Boba Fett and Prime signature sets.',
    color: '#b388ff',
    accentColor: '#f0c040',
    dataFile: '2022-finest',
  },
  {
    id: '2018-finest',
    type: 'Other',
    name: '2018 Topps Star Wars Finest',
    shortName: 'Finest 2018',
    year: 2018,
    brand: 'Topps Finest',
    category: 'Star Wars',
    releaseDate: 'November 28, 2018',
    totalCards: 369,
    description: 'The first Star Wars Finest — 100 base cards spanning the saga with a full Refractor rainbow, a 20-card Extended Base run, Droids and Vehicles, and dedicated Rogue One and Solo inserts. The hits are Lightsaber Hilt Medallion cards numbered to 99, a 31-signer Finest Autographs program, a 12-signer Rogue One set, eight Prime Autographs, and 103 sketch artists.',
    color: '#ffab40',
    accentColor: '#f0c040',
    dataFile: '2018-finest',
  },
  {
    id: '2023-signature-series',
    type: 'Signature',
    name: '2023 Topps Star Wars Signature Series',
    shortName: '2023 Signature Series',
    year: 2023,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'March 31, 2023',
    totalCards: 209,
    description: 'The all-autograph product — one encased autograph per box across 134 Design A signers, 67 Design B cards on the 1983 Return of the Jedi 40th anniversary design, dual and triple autographs, and two one-of-one Light Side / Dark Side quad autographs.',
    color: '#ff5d5d',
    accentColor: '#f0c040',
    dataFile: '2023-signature-series',
    new: true,
  },
  {
    id: '2023-star-wars',
    type: 'Other',
    name: '2023 Topps Star Wars',
    shortName: 'Star Wars Flagship 2023',
    year: 2023,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'August 4, 2023',
    totalCards: 314,
    description: 'The first-ever paper Star Wars flagship set — a 100-card base with a twelve-tier foilboard-to-Hyperspace parallel rainbow, nine insert lines from Comic Covers to the Kyber Crystal Die-Cuts, oversized Widevision box toppers, and an 18-signer autograph program.',
    color: '#ffb300',
    accentColor: '#f0c040',
    dataFile: '2023-star-wars',
    new: true,
  },
  {
    id: '2023-obi-wan-kenobi',
    type: 'Other',
    name: '2023 Topps Star Wars Obi-Wan Kenobi',
    shortName: 'Obi-Wan Kenobi 2023',
    year: 2023,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'May 31, 2023',
    totalCards: 244,
    description: 'The Disney+ series set — a 100-card base chronicling all six chapters, Heroes and Darth Vader & the Inquisitorius inserts with /5 Black Metal variations, Original Art reprints, a 25-signer autograph program with duals and triples, sourced fabric relics, coin medallions, and blaster-exclusive manufactured patches.',
    color: '#4d9fff',
    accentColor: '#f0c040',
    dataFile: '2023-obi-wan-kenobi',
    new: true,
  },
  {
    id: '2023-chrome',
    type: 'Chrome',
    name: '2023 Topps Star Wars Chrome',
    shortName: '2023 Chrome',
    year: 2023,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'May 24, 2023',
    totalCards: 100,
    description: 'The first flagship Chrome release — 100 characters and the actors who played them, with a 55-signer autograph program.',
    color: '#ff9100',
    accentColor: '#f0c040',
    dataFile: '2023-chrome',
  },
  {
    id: '2023-chrome-galaxy',
    type: 'Galaxy',
    name: '2023 Topps Chrome Star Wars Galaxy',
    shortName: '2023 Galaxy',
    year: 2023,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'August 30, 2023',
    totalCards: 100,
    description: 'Art-driven chromium cards featuring classic and new Star Wars Galaxy artwork.',
    color: '#00e87a',
    accentColor: '#c9a227',
    dataFile: '2023-chrome-galaxy',
  },
  {
    id: '2022-chrome-galaxy',
    type: 'Galaxy',
    name: '2022 Topps Chrome Star Wars Galaxy',
    shortName: '2022 Galaxy',
    year: 2022,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'December 28, 2022',
    totalCards: 100,
    description: 'Classic Galaxy artwork on chromium stock with Retro Rewind and Gameplay Galaxy inserts.',
    color: '#ff9100',
    accentColor: '#c9a227',
    dataFile: '2022-chrome-galaxy',
  },
  {
    id: '2022-signature-series',
    type: 'Signature',
    name: '2022 Topps Star Wars Signature Series',
    shortName: '2022 Signature Series',
    year: 2022,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'February 16, 2022',
    totalCards: 211,
    description: 'The second all-autograph Signature Series — one encased autograph per box across 146 A-design cards and over 100 signers, 56 B-design variants on a 1980 Empire Strikes Back-inspired design, plus dual and triple autographs and the line\'s first quad autographs, all one-of-ones led by a Ford / Fisher / Ridley / Driver book.',
    color: '#4d9fff',
    accentColor: '#f0c040',
    dataFile: '2022-signature-series',
    new: true,
  },
  {
    id: '2021-chrome-legacy',
    type: 'Chrome',
    name: '2021 Topps Chrome Star Wars Legacy',
    shortName: '2021 Chrome Legacy',
    year: 2021,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'October 20, 2021',
    totalCards: 487,
    description: 'Story moments from the modern films and shows on chromium — a 200-card base, concept-art inserts including Star Wars: Visions, serial-numbered ship medallions, and the Age of Republic, Rebellion, and Resistance autograph programs.',
    color: '#ffd54f',
    accentColor: '#2979ff',
    dataFile: '2021-chrome-legacy',
    new: true,
  },
  {
    id: '2021-stellar-signatures',
    type: 'Other',
    name: '2021 Topps Star Wars Stellar Signatures',
    shortName: 'Stellar Signatures 2021',
    year: 2021,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'December 22, 2021',
    totalCards: 245,
    description: 'Ultra-premium box set limited to 100 boxes — on-card single, dual and quad autographs, a 100-card sketch reproduction set, and one-of-one oversized sketch cards.',
    color: '#c9a227',
    accentColor: '#b060ff',
    dataFile: '2021-stellar-signatures',
  },
  {
    id: '2021-signature-series',
    type: 'Signature',
    name: '2021 Topps Star Wars Signature Series',
    shortName: '2021 Signature Series',
    year: 2021,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'February 17, 2021',
    totalCards: 179,
    description: 'The product that launched the all-autograph Signature Series line — one encased autograph per box across 163 cards and over 100 signers with up to three image variations each, from Harrison Ford, Carrie Fisher, and Ewan McGregor to the deepest cast cuts, plus eight dual and eight triple autographs.',
    color: '#e0e0e8',
    accentColor: '#f0c040',
    dataFile: '2021-signature-series',
    new: true,
  },
  {
    id: '2021-chrome-galaxy',
    type: 'Galaxy',
    name: '2021 Topps Chrome Star Wars Galaxy',
    shortName: '2021 Galaxy',
    year: 2021,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'August 25, 2021',
    totalCards: 100,
    description: 'The inaugural Chrome Galaxy release bringing classic Galaxy artwork to chromium for the first time.',
    color: '#f0c040',
    accentColor: '#00d4ff',
    dataFile: '2021-chrome-galaxy',
    // Set Summary card gallery. Points at CK's own reference photos in the
    // public card-images bucket (prod URL so every environment renders them);
    // sections lists which checklist section ids have photo coverage.
    summaryGallery: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base'],
      // Also use these reference photos as the My Checklist thumbnail fallback
      // for cards the collector hasn't photographed (gold corner triangle).
      checklistFallback: true,
    },
  },
  {
    id: '2025-smugglers-outpost',
    type: 'Other',
    name: "2025 Star Wars Smuggler's Outpost",
    shortName: "Smuggler's Outpost 2025",
    year: 2025,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: '2025',
    totalCards: 806,
    description: "A massive multi-format set spanning three base sets, nine insert sets, sketch cards, and an extensive autograph program.",
    color: '#8b4a00',
    accentColor: '#d4a855',
    dataFile: '2025-smugglers-outpost',
    new: true,
    // My Checklist reference-photo fallback — Finest base only (75 fronts +
    // backs verified); chrome-black-base and galactic-antiquities-base have no
    // CK photos yet — add their section ids here once photographed.
    checklistFallback: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['finest-base'],
    },
  },
  {
    id: '2018-galactic-files',
    type: 'Other',
    name: '2018 Topps Star Wars Galactic Files',
    shortName: 'Galactic Files 2018',
    year: 2018,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'August 10, 2018',
    totalCards: 596,
    description: "The encyclopedia's second volume — 200 more base cards that continue 2017 Galactic Files Reborn's section numbering and add The Last Jedi, chased by Orange through White /5 and Red 1/1. Seven inserts from Band of Heroes to Sinister Syndicates, the 25-card 2017 Base Image Variations short prints, a 44-signer autograph program with Ford, Fisher, Ridley, Christensen and Tennant, dual and triple autographs, a six-person Rogue One signing, 8 Source Material Fabric Swatches numbered to 50, 56 Manufactured Movie Poster Patch cards, and 179 sketch artists.",
    color: '#7b1fa2',
    accentColor: '#ff9100',
    dataFile: '2018-galactic-files',
    new: true,
  },
  {
    id: '2017-galactic-files-reborn',
    type: 'Other',
    name: '2017 Topps Star Wars Galactic Files Reborn',
    shortName: 'Galactic Files Reborn 2017',
    year: 2017,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'July 19, 2017',
    totalCards: 456,
    description: "The character encyclopedia returns — 200 base cards across ten film and series sections from The Phantom Menace to The Force Awakens, each with its own numbering, under an Orange-to-Red 1/1 color chase. Five inserts (Famous Quotes, Galactic Moments, Locations, Vehicles, Weapons), a 62-signer autograph program with Ford, Hamill, Fisher, Driver and Ridley, dual and triple autographs, a six-person 1/1 autograph led by Ian McDiarmid, 32 Vehicle Medallions, and 80 sketch artists.",
    color: '#0288d1',
    accentColor: '#ff9100',
    dataFile: '2017-galactic-files-reborn',
    new: true,
  },
  {
    id: '2022-book-of-boba-fett',
    type: 'Other',
    name: '2022 Topps Star Wars: The Book of Boba Fett',
    shortName: 'Book of Boba Fett 2022',
    year: 2022,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: 'November 23, 2022',
    totalCards: 205,
    description: "Season 1 of the Disney+ series in 100 base cards under a nine-deep chase — Blue and Purple, Red /99 down to Gold /10, Black 1/1 and the hobby-only Metal Variation 1/1. Four inserts (Heroes & Villains, Concept Art, Aliens & Creatures, Boba Fett's Arsenal), 21 on-card autograph signers led by Temuera Morrison, Ming-Na Wen and Rosario Dawson, dual and triple autographs, 20 Commemorative Patch cards from the blaster boxes, and screen-used Prop and Sourced Fabric Relics.",
    color: '#b71c1c',
    accentColor: '#d4a855',
    dataFile: '2022-book-of-boba-fett',
    new: true,
  },
  {
    id: '2015-chrome-perspectives',
    type: 'Chrome',
    name: '2015 Topps Star Wars Chrome Perspectives: Jedi vs. Sith',
    shortName: '2015 Chrome Perspectives',
    year: 2015,
    brand: 'Topps Chrome',
    category: 'Star Wars',
    releaseDate: 'August 21, 2015',
    totalCards: 333,
    description: 'The galaxy from both sides — 100 base cards telling the same 50 stories twice, once from the Jedi Temple Archives and once from the Sith Information Guide, under a Refractor rainbow topped by the Superfractor. Five themed inserts from wanted posters to Sith propaganda, 22 on-card autograph signers, dual and triple autographs pairing Hamill, Fisher, Prowse, McDiarmid and Park, 36 duel Medallion cards in Bronze, Silver and Gold, a Force Awakens preview insert, and 106 chromium sketch artists.',
    color: '#2979ff',
    accentColor: '#ff1744',
    dataFile: '2015-chrome-perspectives',
    new: true,
  },
  {
    id: '2018-galaxy',
    type: 'Galaxy',
    name: '2018 Topps Star Wars Galaxy',
    shortName: '2018 Galaxy',
    year: 2018,
    brand: 'Topps',
    category: 'Star Wars',
    releaseDate: '2018',
    totalCards: 100,
    description: 'The classic Star Wars Galaxy series returns with New Visions and Archives base cards, plus Rogue One Propaganda, Journey of Ahsoka and more.',
    color: '#ff1744',
    accentColor: '#f0c040',
    dataFile: '2018-galaxy',
  },
  {
    id: "2025-masterwork",
    type: 'Masterwork',
    name: "2025 Topps Star Wars Masterwork",
    shortName: "Masterwork 2025",
    year: 2025,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2025",
    totalCards: 868,
    description: "Topps' premium Star Wars release: a 100-card base of refractor-style parallels, on-card autographs from a 96-signer roster, Skeleton Crew and ROTJ Film Cel relics, Ultimate Book Card and Pen Autograph relics, and 1/1 hand-drawn sketch cards from 200+ artists.",
    color: "#c9a227",
    accentColor: "#f0c040",
    dataFile: "2025-masterwork",
  },
  {
    id: "2025-chrome-costco",
    type: 'Chrome',
    name: "2025 Topps Chrome Star Wars Costco Exclusive",
    shortName: "2025 Chrome Costco",
    year: 2025,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2025",
    totalCards: 106,
    description: "The Costco SuperBox exclusive: 50 Characters Design Variation cards with an eight-parallel refractor rainbow, oversized Heads Up Die-Cuts (1 per SuperBox), and Design Variation autographs.",
    color: "#4d9fff",
    accentColor: "#f0c040",
    dataFile: "2025-chrome-costco",
  },
  {
    id: "2024-chrome-costco",
    type: 'Chrome',
    name: "2024 Topps Chrome Star Wars Costco Exclusive",
    shortName: "2024 Chrome Costco",
    year: 2024,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2024",
    totalCards: 60,
    description: "The first Costco Super Box exclusive: a 50-card exclusive Chrome set with its own numbering, a Refractor parallel plus Red/Blue /10 and Red /5 chases, and the ten Heads Up Die Cuts.",
    color: "#4d9fff",
    accentColor: "#f0c040",
    dataFile: "2024-chrome-costco",
    new: true,
  },
  {
    id: "2025-chrome-the-national",
    type: 'Chrome',
    name: "2025 Topps Chrome Star Wars The National",
    shortName: "2025 Chrome The National",
    year: 2025,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2025",
    totalCards: 30,
    description: "Topps 2025 Topps Chrome Star Wars The National trading card set.",
    color: "#b060ff",
    accentColor: "#f0c040",
    dataFile: "2025-chrome-the-national",
  },
  {
    id: "2024-masterwork",
    type: 'Masterwork',
    name: "2024 Topps Star Wars Masterwork",
    shortName: "Masterwork 2024",
    year: 2024,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2024",
    totalCards: 519,
    description: "Topps' premium Star Wars release: a 100-card base on 72-point stock, all-metal Artoo-Detoo and See-Threepio short prints, relics from a screen-used Force Awakens Stormtrooper costume and Disney's Rise of the Resistance ride, a six-tier autograph program with two autographs per box, and 1/1 sketch cards from a 182-artist roster.",
    color: "#00d4ff",
    accentColor: "#f0c040",
    dataFile: "2024-masterwork",
  },
  {
    id: "2022-masterwork",
    type: 'Masterwork',
    name: "2022 Topps Star Wars Masterwork",
    shortName: "Masterwork 2022",
    year: 2022,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2022",
    totalCards: 605,
    description: "Topps' premium Star Wars release: a 100-card base on 72-point stock, three insert lines with 1/1 Gold Metal variations, the line's first autographed relics across costumes, Rogue One props, stamps, and medallions, a 63-signer on-card autograph roster, and 1/1 sketch cards in four formats from a 94-artist roster.",
    color: "#ff9100",
    accentColor: "#f0c040",
    dataFile: "2022-masterwork",
  },
  {
    id: "2021-masterwork",
    type: 'Masterwork',
    name: "2021 Topps Star Wars Masterwork",
    shortName: "Masterwork 2021",
    year: 2021,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2021",
    totalCards: 429,
    description: "Topps' premium Star Wars release: a 100-card base, Lucasfilm 50th Anniversary inserts with metal and gold metal variations, jumbo costume relics, manufactured medallions, stamp cards, and a 52-signer on-card autograph program with duals, triples, quad books, and the one-of-one Galactic Autograph Book.",
    color: "#b060ff",
    accentColor: "#f0c040",
    dataFile: "2021-masterwork",
  },
  {
    id: "2020-masterwork",
    type: 'Masterwork',
    name: "2020 Topps Star Wars Masterwork",
    shortName: "Masterwork 2020",
    year: 2020,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2020",
    totalCards: 497,
    description: "Topps' premium Star Wars release: a 100-card base, Empire Strikes Back 40th Anniversary inserts, commemorative dog tag medallions, stamp cards, a 51-signer autograph program from The Mandalorian's debut cast to the classic trilogy, and 1/1 sketch cards from a 113-artist roster.",
    color: "#ff4444",
    accentColor: "#f0c040",
    dataFile: "2020-masterwork",
  },
  {
    id: "2019-masterwork",
    type: 'Masterwork',
    name: "2019 Topps Star Wars Masterwork",
    shortName: "2019 Masterwork",
    year: 2019,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2019",
    totalCards: 531,
    description: "Topps' premium Star Wars release: a 100-card base, jumbo costume relics, film cel relics, artifact medallions, a 59-signer autograph roster with duals, triples, quads, and the one-of-one Ultimate Autograph Book, and 1/1 sketch cards from a 122-artist roster.",
    color: "#00e87a",
    accentColor: "#f0c040",
    dataFile: "2019-masterwork",
  },
  {
    id: "2018-masterwork",
    type: 'Masterwork',
    name: "2018 Topps Star Wars Masterwork",
    shortName: "Masterwork 2018",
    year: 2018,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2018",
    totalCards: 508,
    description: "Topps' premium Star Wars release: a 100-card base with 25 short prints on 72-point stock, source-material fabric swatches, vehicle patch and stamp cards, a 49-signer autograph program with duals, triples, and quad book cards, and 1/1 sketch cards from a 134-artist roster.",
    color: "#4d9fff",
    accentColor: "#f0c040",
    dataFile: "2018-masterwork",
  },
  {
    id: "2023-chrome-black",
    type: 'Black',
    name: "2023 Topps Star Wars Chrome Black",
    shortName: "Chrome Black 2023",
    year: 2023,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2023",
    totalCards: 267,
    description: "Topps' premium dark-themed Chrome release: a 100-card base on black chromium stock, Animated Short Prints and Fantastic Fights inserts, and a 117-card autograph program crowned by the all-red Dark Side and all-blue Light Side autographs, with an encased autograph in every box.",
    color: "#b060ff",
    accentColor: "#f0c040",
    dataFile: "2023-chrome-black",
  },
  {
    id: "2022-chrome-black",
    type: 'Black',
    name: "2022 Topps Star Wars Chrome Black",
    shortName: "Chrome Black 2022",
    year: 2022,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "November 2, 2022",
    totalCards: 240,
    description: "Topps' premium dark-themed Chrome release: a 100-card base on black chromium stock and a 140-card autograph program across four designs — the A and B design signers plus Dark Side and Galactic Black autographs — with an encased autograph in every box.",
    color: "#4fc3f7",
    accentColor: "#f0c040",
    dataFile: "2022-chrome-black",
  },
  {
    id: "2022-mandalorian-chrome",
    type: 'Chrome',
    name: "2022 Topps Star Wars The Mandalorian Chrome Beskar Edition",
    shortName: "2022 Chrome Mandalorian",
    year: 2022,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "August 31, 2022",
    totalCards: 237,
    description: "The first two seasons of The Mandalorian on chromium: a 100-card base retelling the show chapter by chapter plus 25 all-new short prints, four insert lines including the Legends die-cuts, and a 39-signer autograph program led by Pedro Pascal — with an autograph or sketch in every box.",
    color: "#b8c4d0",
    accentColor: "#f0c040",
    dataFile: "2022-mandalorian-chrome",
  },
  {
    id: "2024-galactic-antiquities",
    type: 'Other',
    name: "2024 Topps Star Wars Galactic Antiquities",
    shortName: "Galactic Antiquities 2024",
    year: 2024,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "2024",
    totalCards: 212,
    description: "Topps 2024 Topps Star Wars Galactic Antiquities trading card set.",
    color: "#888aa0",
    accentColor: "#f0c040",
    dataFile: "2024-galactic-antiquities",
  },
  {
    id: "1977-series-1",
    type: 'Other',
    name: "1977 Topps Star Wars Series 1",
    shortName: "Series 1 1977",
    year: 1977,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "1977",
    totalCards: 77,
    description: "Where it all began — Topps' first Star Wars series from 1977: 66 blue-bordered cards and 11 stickers covering A New Hope.",
    color: "#4d9fff",
    accentColor: "#f0c040",
    dataFile: "1977-series-1",
    checklistCredit: "jawacards",
    // My Checklist reference-photo fallback (fronts only — no backs uploaded).
    checklistFallback: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base', 'sticker'],
    },
  },
  {
    id: "1977-series-2",
    type: 'Other',
    name: "1977 Topps Star Wars Series 2",
    shortName: "Series 2 1977",
    year: 1977,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "1977",
    totalCards: 77,
    description: "The second 1977 Topps series: 66 red-bordered cards and 11 stickers continuing the story of A New Hope.",
    color: "#ff4444",
    accentColor: "#f0c040",
    dataFile: "1977-series-2",
    checklistCredit: "jawacards",
    // My Checklist reference-photo fallback (fronts only — no backs uploaded;
    // base #74 has no photo yet and keeps its empty slot).
    checklistFallback: {
      storageBase: 'https://yvcmwvqymcnrtvvsywue.supabase.co/storage/v1/object/public/card-images/8eca5223-ed49-401c-9ac6-530a691286ed',
      sections: ['base', 'sticker'],
    },
  },
  {
    id: "1977-series-3",
    type: 'Other',
    name: "1977 Topps Star Wars Series 3",
    shortName: "Series 3 1977",
    year: 1977,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "1977",
    totalCards: 77,
    description: "The third 1977 Topps series: 66 yellow-bordered cards and 11 stickers, adding behind-the-scenes looks at A New Hope.",
    color: "#ffd54f",
    accentColor: "#f0c040",
    dataFile: "1977-series-3",
    checklistCredit: "jawacards",
  },
  {
    id: "1977-series-4",
    type: 'Other',
    name: "1977 Topps Star Wars Series 4",
    shortName: "Series 4 1977",
    year: 1977,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "1977",
    totalCards: 78,
    description: "The fourth 1977 Topps series: 66 green-bordered cards and 11 stickers — checklisted with both versions of the infamous C-3PO card #207.",
    color: "#00e87a",
    accentColor: "#f0c040",
    dataFile: "1977-series-4",
    checklistCredit: "jawacards",
  },
  {
    id: "1977-series-5",
    type: 'Other',
    name: "1977 Topps Star Wars Series 5",
    shortName: "Series 5 1977",
    year: 1977,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "1977",
    totalCards: 77,
    description: "The fifth and final 1977 Topps series: 66 orange-bordered cards and 11 stickers closing out the original A New Hope run.",
    color: "#ff9100",
    accentColor: "#f0c040",
    dataFile: "1977-series-5",
    checklistCredit: "jawacards",
  },
  {
    id: "1977-series-1-mexico-edition",
    type: 'Other',
    name: "1977 Series 1 Mexico Edition",
    shortName: "Series 1 Mexico Edition 1977",
    year: 1977,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "1977",
    totalCards: 67,
    description: "The Spanish-language Mexico edition of the 1977 Series 1: 66 cards plus a promo card.",
    color: "#00d4ff",
    accentColor: "#f0c040",
    dataFile: "1977-series-1-mexico-edition",
    checklistCredit: "jawacards",
  },
  {
    id: "1977-general-mills-punch-out-cards",
    type: 'Other',
    name: "1977 General Mills Star Wars Punch-out Cards",
    shortName: "General Mills Punch-out Cards 1977",
    year: 1977,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "1977",
    totalCards: 4,
    description: "Four punch-out cards issued on General Mills cereal boxes during the original Star Wars promotion.",
    color: "#b060ff",
    accentColor: "#f0c040",
    dataFile: "1977-general-mills-punch-out-cards",
    checklistCredit: "jawacards",
  },
  {
    id: "1977-allens-regina-new-zealand",
    type: 'Other',
    name: "1977 Star Wars Allen's & Regina (New Zealand)",
    shortName: "Allen's & Regina (New Zealand) 1977",
    year: 1977,
    brand: "Topps",
    category: 'Star Wars',
    releaseDate: "1977",
    totalCards: 72,
    description: "The New Zealand release from confectioners Allen's & Regina: a 72-card set of original Star Wars imagery.",
    color: "#e0e0e8",
    accentColor: "#f0c040",
    dataFile: "1977-allens-regina-new-zealand",
    checklistCredit: "jawacards",
  },
];
